var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Confirm", {
    ref: "confirmRef",
    attrs: { "max-width": _vm.maxWidth },
    scopedSlots: _vm._u([
      {
        key: "card-title",
        fn: function (ref) {
          var close = ref.close
          return [
            _c("v-card-title", { staticClass: "alert-dialog__header" }, [
              _c(
                "div",
                { staticClass: "alert-dialog__header-inner" },
                [
                  _c("span", { staticClass: "text-h6 alert-dialog__title" }, [
                    _vm._v(_vm._s(_vm.displayTitle)),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "alert-dialog__close",
                      attrs: { depressed: "", icon: "" },
                      on: { click: close },
                    },
                    [
                      _c("v-icon", { attrs: { size: "18" } }, [
                        _vm._v("close"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "risk-dialog__message" }, [
              _vm._v("\n      " + _vm._s(_vm.displayMessage) + "\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function (ref) {
          var close = ref.close
          return [
            _c("v-spacer"),
            _c(
              "v-btn",
              {
                staticClass: "text-none",
                attrs: { depressed: "", text: "", color: "blue darken-1" },
                on: { click: close },
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("btn_close")) + "\n    ")]
            ),
            _c("v-spacer"),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }